import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));

const renderApp = () => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

renderApp();

// Optional: HMR for App only
if (import.meta.hot) { // Vite / modern bundlers
  import.meta.hot.accept("./App", () => {
    renderApp();
  });
} else if (module.hot) { // CRA / Webpack
  module.hot.accept("./App", () => {
    renderApp();
  });
}